module.exports = __webpack_public_path__ + "img/b-green-s@3x.5de8f0db.png";